import { API_URL } from "./urls";
import axios from "axios";

export const getSubscriptions = async ({publicUserId})=> await axios.post(
    `${API_URL}/get-subscriptions`,
    {
      publicUserId,
    }
  );